import styles from './Tooltip.module.scss';
import TooltipWithRef from "./TooltipWithRef";
import { useRef, useCallback, useState } from "react";

export interface ITooltipProps {
  action: React.ReactElement;
  position?: "top" | "left" | "right" | "bottom";
  align?: "start" | "center" | "end";
  bottom?: number;
  left?: number;
  right?: number;
  text: React.ReactNode;
  top?: number;
  whiteSpace?: string;
  disabled?: boolean;
  maxWidth?: number;
}

const Tooltip: React.FC<ITooltipProps> = (props: ITooltipProps): React.ReactElement => {
  const triggerRef = useRef<HTMLDivElement>(null);
  const [_, setHasRef] = useState<Boolean>(false);

  const rectRef = useCallback((node: HTMLDivElement | null) => {
    if (node !== null) {
      setHasRef(Boolean(node));
      // @ts-ignore
      triggerRef.current = node;
    }
  }, []);

  return (
    <div
      ref={rectRef}
      className={styles.action}
      // onMouseEnter={onMouseEnter}
      // onMouseLeave={onMouseLeave}
    >
      {props.action}
      <TooltipWithRef
        triggerRef={triggerRef}
        position={props.position}
        align={props.align}
        bottom={props.bottom}
        left={props.left}
        right={props.right}
        text={props.text}
        top={props.top}
        whiteSpace={props.whiteSpace}
        disabled={props.disabled}
        maxWidth={props.maxWidth}
      />
    </div>
  );
};

export default Tooltip;
